// Home.js
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Home.css'; // Import your CSS styles
import Chatbot from '../components/Chatbot';
import ViewportSize from '../components/ViewportSize';
import Card from '../components/Card';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap JS Bundle (Optional if you use nav toggle)

const Home = () => {
  const [activeBox, setActiveBox] = useState(null);
  const navigate = useNavigate();

  const handleMouseDown = (box) => {
    setActiveBox(box);
  };

  const handleMouseUp = (path) => {
    setActiveBox(null);
    setTimeout(() => {
      navigate(path);
    }, 150);
  };

  const handleStart = (box) => {
    setActiveBox(box);
  };

  const handleEnd = (path) => {
    setActiveBox(null);
    setTimeout(() => {
      navigate(path);
    }, 150);
  };

  const cardData = [
    { id: 'delivery', title: 'Delivery aaS', description: 'Deliver up to 10kg in confidence', icon:'rickshaw.png', path: '/delivery' },
    { id: 'project', title: 'Project aaS', description: 'Projects managed professionally', icon:'pmp.png', path: '/project' },
    { id: 'management', title: 'GM\naaS', description: 'FTE-optimal general management', icon:'quantic.png', path: '/abc' },
    { id: 'dataprotection', title: 'DPO\naaS', description: 'PDPA-compliant data protection', icon:'pdpc.png', path: '/dpo' },
    { id: 'siem', title: 'SIEM\naaS', description: 'Security monitoring for peace of mind', icon:'cc.png', path: '/siem' },
    { id: 'smartsearch', title: 'Search aaS', description: 'Insights from your very own data pond', icon:'nuscomp.png', path: '/search' },
    { id: 'aboutus', title: 'About\naaS', description: 'Your business value is our motivation', icon:'rickshaw.png', path: '/aboutus' },
    { id: 'joinus', title: 'Join\naaS', description: 'Become a valued Deliveranzer', icon:'profile.png', path: '/joinus' },
  ];

  return (
    <>
      <div style={{ backgroundImage: 'url(/asphalt.jpg)', backgroundRepeat: 'repeat', backgroundSize: 'auto', backgroundPosition: 'center', backgroundAttachment: 'fixed', minHeight: '100vh' }}>
        {/* Navigation Bar (Bootstrap component) */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-secondary">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">Deliveranz BETA</a>
            {/* <ViewportSize /> */}
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <NavLink className="nav-link active" to="/">Dashboard</NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/courses">Courses</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/login">Profile</NavLink>
                </li> */}
              </ul>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="container mt-4">

          {/* Responsive Flexbox Section */}
          <section className="feature-box">
            {cardData.map(card => (
              <Card
                key={card.id}
                id={card.id}
                title={card.title}
                description={card.description}
                icon={card.icon}
                isActive={activeBox === card.id}
                onMouseDown={() => handleMouseDown(card.id)}
                onMouseUp={() => handleMouseUp(card.path)}
                onTouchStart={() => handleStart(card.id)}
                onTouchEnd={() => handleEnd(card.path)}
              />
            ))}
          </section>
        </main>
        {/* Bootstrap JS Bundle (Optional if you use nav toggle) */}
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>     
      </div>  
    </>
  );
};

export default Home;
